import React, { useEffect, useState } from 'react';

import ProgressCircle from "./components/ProgressCircle"


import { CardWrapper } from './style';

import BackComponent from '../atoms/backComponent';

import Container from '../atoms/Container/Container';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';

import { useIsFocused } from '@react-navigation/native';
import { tenantActions } from '../../redux/tenant.actions';
import { useDispatch } from 'react-redux';
import Reports from '../../../maintenance/reports/Reports';



const Maintenance = (props) => {
  const [flowId, setFlowId] = React.useState(null);
  const dispatch = useDispatch()

  const focused = useIsFocused();
  useEffect(() => {
    if (props?.route?.params?.id) {
      setFlowId(props?.route?.params?.id);
      fetchFlows()
    }
  }, [props?.route?.params?.id, focused]);
  const fetchFlows = async () => {
    dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
  }
  return (
  
<>

        <ProgressCircle props={props} />
       
      <Reports
          id={props?.route?.params?.id}
        />
   </>
  );
};

export default drawerHoc({
  Component: Maintenance,
  showBackButton: true,
  backNavigation: "CurrentOnboards",
  customWidth:"70%"
});
